import utils from 'utils'

class billTemplateModal {
    constructor($scope, httpRequest, globalFn, logger, $uibModalInstance, items1, $stateParams, $uibModal) {
        const types = ['preferential_code']
        httpRequest.get_dictByTypeArr(types).then((res) => {
            $scope.dictData = res.data.value
        })
        httpRequest.post_getTax4InvoiceDetailInfo(items1).then((res) => {
            $scope.invoice = res.data.value
            $scope.chineseAmtTotal = globalFn.digitUppercase($scope.invoice.adValoremTotal)
        })
        // 关闭
        $scope.cancel = function cancel() {
            $uibModalInstance.dismiss('cancel')
        }
        // 确定
        $scope.ok = function ok() {
            // 返回数据
            $uibModalInstance.close()
        }
    }
}

billTemplateModal.$inject = ['$scope', 'httpRequest', 'globalFn', 'logger', '$uibModalInstance', 'items1', '$stateParams', '$uibModal']
export default billTemplateModal



// WEBPACK FOOTER //
// ./src/app/outputManage/fullElectricInvoice/redInkConfirmForm/directive/selectTicket/billTemplateModal.js